import { plugin, debug, join, type DropdownProps } from 'light-component';
import { Button, Dropdown, type MenuProps } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { t } from '../../i18n';
import styles from './style.module.less';
import { WidgetGridDropdown } from './widget-grid-dropdown';
import type { IconNames } from 'zf-web-components/icons';
import type { ReactElement } from 'react';

export function WidgetDropdown(props: DropdownProps): ReactElement {
  debug.widget('dashboard dropdown', props);

  if (props.origin === 'grid') {
    return (<WidgetGridDropdown {...props} />);
  }

  const items: MenuProps['items'] = props?.options?.map(item => {
    if (item.type === 'divider') {
      return { type: 'divider' };
    }
    return {
      label: t(item.title),
      key: item.value,
      icon: item.icon,
      onClick: () => item.onClick?.(item)
    };
  }) ?? [];

  const handleMenuClick: MenuProps['onClick'] = (item: { key: string | null }) => (item.key != null && props.onSelect?.(item.key));
  return (
    <div className={join(styles.dropDown, props?.className)}>
      <Dropdown
        menu={{ items, onClick: handleMenuClick }}
        overlayClassName={styles.dropDownOverlay}
        className={`${props.className ?? ''}`}>
        {
          props.button == null
            ? (
              <span style={props.style}>
                <Icons name={props.icon as IconNames} />
              </span>
            )
            : (
              <Button
                icon={props.icon != null ? <Icons name={props.icon as IconNames} /> : null}
                type='primary'
                style={props.style}>
                {t(props.title ?? '')}
              </Button>
            )
        }
      </Dropdown>
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'dropdown', component: WidgetDropdown });
